import type * as React from 'react';

import { Utilities } from '../../../MedicareProAPI/Utilities/Utilities';

export interface ConsentAFormProps {
  onChange: ({}) => void;
  formData: any;
}
/**
 * Component for filling out a Consent Form A
 *
 * @author Andrew Brown <abrown@medicareprocrm.com>
 */
export const ConsentAForm = (props: ConsentAFormProps): React.JSX.Element => {
  return (
    <>
      <div className="row gutter-2">
        <div className="col-12 p-2 font-weight-bold border-top border-info mt-3 mb-2 boldHeaderLabel">
          Consumer Information
        </div>

        <div className="col-12 col-lg-7 mb-2">
          <label className="label">Consumer Name</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaBeneficiaryName"
            value={props.formData.soaBeneficiaryName}
            onChange={props.onChange}
            required
          />
          {!props.formData.soaBeneficiaryName && (
            <small className="text-danger">Field is required</small>
          )}
        </div>
        <div className="col-12 col-lg-5 mb-2">
          <label className="label">Consumer Phone</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaBeneficiaryPhone"
            value={props.formData.soaBeneficiaryPhone}
            onChange={props.onChange}
            required
          />
          {!props.formData.soaBeneficiaryPhone && (
            <small className="text-danger">Field is required</small>
          )}
        </div>
        <div className="col-12  mb-2">
          <label className="label">Consumer Address</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaBeneficiaryAddress"
            value={props.formData.soaBeneficiaryAddress}
            onChange={props.onChange}
            required
          />
          {!props.formData.soaBeneficiaryAddress && (
            <small className="text-danger">Field is required</small>
          )}
        </div>
      </div>
      <div className="row gutter-2">
        <div className="col-12 p-2 font-weight-bold border-top border-info mt-3 mb-2 boldHeaderLabel">
          Agent Information
        </div>

        <div className="col-12 col-lg-4 mb-2">
          <label className="label">Agent Name</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaAgentName"
            value={props.formData.soaAgentName}
            onChange={props.onChange}
            required
          />
          {!props.formData.soaAgentName && <small className="text-danger">Field is required</small>}
        </div>
        <div className="col-12 col-lg-4 mb-2">
          <label className="label">Agent Phone</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaAgentPhone"
            value={props.formData.soaAgentPhone}
            onChange={props.onChange}
            required
          />
          {!props.formData.soaAgentPhone && (
            <small className="text-danger">Field is required</small>
          )}
        </div>
        <div className="col-12 col-lg-4 mb-2">
          <label className="label">Agent NPN</label>
          <input
            type="text"
            className="form-control form-control-sm keep"
            name="soaAgentNpn"
            value={props.formData.soaAgentNpn}
            onChange={props.onChange}
          />
        </div>
        <div className="col-12">
          <div className="alert alert-info p-1" style={{ fontSize: '9pt' }}>
            <i className="far fa-info-circle mr-1"></i>You will sign the document once its been
            completed by the beneficiary. Your dashboard will list documents that need your
            attention. Click{' '}
            <a href="https://www.medicareproapp.com/agent/settings/index/notifications">here</a> to
            configure notifications.
          </div>
        </div>
      </div>
    </>
  );
};
